import { render, staticRenderFns } from "./TableSorter.vue?vue&type=template&id=3f31cc7c&scoped=true&"
import script from "./TableSorter.vue?vue&type=script&lang=js&"
export * from "./TableSorter.vue?vue&type=script&lang=js&"
import style0 from "./TableSorter.vue?vue&type=style&index=0&id=3f31cc7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f31cc7c",
  null
  
)

export default component.exports